export class Saldo {
  SALDOT: number = 0;
  SALDOC: number = 0;
  SALDOF: number = 0;
}
